import { BaseElement } from "@/components";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

import { mapStyles } from "@/utils";

import type { GapProps, GapType } from "./gap.types";

@customElement("sb-gap")
export class SbGap extends BaseElement implements GapProps {
  @property() size = "8px";
  @property() type: GapType = "vertical";

  @property() id = "";

  protected createRenderRoot() {
    return this;
  }

  render() {
    // ---------------------------
    // SIZE LOGIC
    // ---------------------------
    let sizeStyle: Record<string, string> = {
      width: "0px",
      height: "0px",
    };

    if (this.type === "vertical") {
      sizeStyle = {
        width: "1px",
        height: this.size,
      };
    } else {
      sizeStyle = {
        height: "1px",
        width: this.size,
      };
    }

    return html`
      <div
        part=${this.id ? this.id : "gap"}
        style=${mapStyles({
          ...sizeStyle,
        })}
      ></div>
    `;
  }
}
